import Hero from '../components/Hero';
import Capabilities from '../components/Capabilities';
import CaseStudyGrid from '../components/CaseStudyGrid';
import ContactSection from '../components/ContactSection';

/**
 * Homepage. Composed of small section components — re-order, drop or add new
 * ones here without touching their internals.
 */
export default function HomePage() {
  return (
    <>
      <Hero />
      <Capabilities />

      {/* Main UX/UI case studies */}
      <CaseStudyGrid
        id="case-studies"
        category="ux"
        eyebrow="Selected work"
        heading="Recent case studies."
        sub="Projects solved through thoughtful, user-focused design."
      />

      {/* Creative Archive — visual / creative-led work */}
      <CaseStudyGrid
        id="creative-archive"
        category="creative"
        eyebrow="Archive"
        heading="Creative projects."
        sub="Creative-led work. Pitches, campaign work and media."
      />

      <ContactSection />
    </>
  );
}
